import axios from 'axios'

const state = () => ({
  videos: []
})

const getters = {
  videos(state) {
    return state.videos
  }
}

const mutations = {
  SET_VIDEOS(state, payload){
    state.videos = payload
  },
  DELETE_VIDEOS(state, id){
    state.videos.results = state.videos.results.filter((x) => x.id != id);
  },
  ADD_VIDEOS(state, data){
    state.videos.results.push(data);
  },
  EDIT_VIDEOS(state, data){
    state.videos.results = state.videos.results.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    })
  }
}

const actions = {
  getVideos({commit}){
    axios.get('https://api.geomalaka.uz/api/main/video/')
      .then((res)=>{
        commit("SET_VIDEOS", res.data)
        // this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  getVideosId({commit}, id){
    axios.get(`https://api.geomalaka.uz/api/main/video/${id}/`)
      .then((res)=>{
        commit("SET_VIDEOS", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  deleteVideos({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/video/${id}/`)
      .then((res)=>{
        commit("DELETE_VIDEOS", id)
        this._vm.$toast('Deleted', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  addVideos({commit}, payload){
    axios.post(`https://api.geomalaka.uz/api/main/video/`, payload)
      .then((res)=>{
        commit("ADD_VIDEOS", res.data)
        this._vm.$toast(res.statusText, {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  editVideos({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/video/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_VIDEOS", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }

}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

